/*
 * STRUGA Smart Search — клиентский «умный» поиск.
 *
 * Зачем: нативный поиск Shopify не индексирует артикулы (variant SKU) и не терпит
 * опечатки/пропуск дефисов. Проверено фактом: точный «K-0490-M» в нативном
 * /search/suggest даёт 0 результатов.
 *
 * Решение: каталог STRUGA маленький (132 товара) и публичный фид /products.json
 * отдаёт ВСЁ — названия (на .ru уже русские), артикулы, теги-фасеты. Поэтому держим
 * весь индекс в браузере и матчим своим лёгким fuzzy-движком (без внешних зависимостей).
 *
 * Архитектура — прогрессивное улучшение: при любой ошибке откатываемся на нативный
 * предиктив темы, поиск не ломается. Источник локализован по домену (.ru → русский,
 * .com → английский) — индекс автоматически на языке витрины.
 *
 * Выбрал свой матчер вместо Fuse.js: для 132 товаров качество идентичное, но нет
 * сетевой зависимости от CDN, нет vendor-версий, полный контроль над скорингом
 * (артикул важнее текста — у внешней либы это не настроишь так точно).
 */
(function () {
  'use strict';

  var FEED = '/products.json?limit=250';
  var CACHE_KEY = 'struga_search_index_v2';
  var CACHE_TTL = 30 * 60 * 1000; // 30 минут — каталог меняется редко
  var MAX_PREDICTIVE = 8;
  var MAX_PAGE = 36;

  /* Словарь синонимов фасетов: тег → формы, по которым ищем (RU + EN).
   * Имена семейств/миров на витрине латиницей (бренд-правило: не переводим),
   * поэтому кириллический запрос «брутализм»/«карбон»/«кольцо» иначе не совпал бы. */
  var SYNONYMS = {
    'family-amulet': ['амулет', 'amulet'],
    'family-blade': ['блейд', 'лезвие', 'blade'],
    'family-brutalism': ['брутализм', 'брутал', 'brutalism'],
    'family-carbon': ['карбон', 'углеволокно', 'карбоновый', 'carbon'],
    'family-dark-union': ['дарк юнион', 'тёмный союз', 'dark union'],
    'family-experimental': ['эксперимент', 'экспериментальный', 'experimental'],
    'family-fused': ['фьюзд', 'сплав', 'fused'],
    'family-mosaic': ['мозаика', 'мозаичный', 'mosaic'],
    'family-signature-asymmetric': ['сигнатур', 'асимметрия', 'асимметричный', 'signature asymmetric'],
    'family-signature-heart': ['сердце', 'сигнатур сердце', 'signature heart', 'heart'],
    'family-thorn': ['торн', 'шип', 'thorn'],
    'world-codex': ['кодекс', 'codex'],
    'world-dark-union': ['дарк юнион', 'тёмный союз', 'dark union'],
    'world-island-artifacts': ['артефакты острова', 'остров', 'island artifacts'],
    'world-lab': ['лаб', 'лаборатория', 'lab'],
    'world-ritual': ['ритуал', 'ритуальный', 'ritual'],
    'material-925-silver': ['серебро', 'серебряный', 'серебро 925', '925', 'silver'],
    'material-carbon-fiber': ['карбон', 'углеволокно', 'карбоновый', 'carbon fiber'],
    'material-meteorite': ['метеорит', 'метеоритный', 'meteorite'],
    'material-quartz': ['кварц', 'кварцевый', 'quartz'],
    'material-silk': ['шёлк', 'шелк', 'silk'],
    'type-bracelet': ['браслет', 'браслеты', 'bracelet'],
    'type-chain': ['цепь', 'цепочка', 'chain'],
    'type-choker': ['чокер', 'choker'],
    'type-costume': ['костюм', 'костюмный', 'costume'],
    'type-cuff': ['кафф', 'каф', 'кафа', 'ушной', 'cuff', 'ear cuff'],
    'type-earring': ['серьга', 'серьги', 'серёжка', 'earring', 'earrings'],
    'type-long-chain': ['длинная цепь', 'длинная цепочка', 'long chain'],
    'type-necklace': ['ожерелье', 'колье', 'подвеска', 'кулон', 'necklace'],
    'type-pin-earring': ['пусет', 'гвоздик', 'пин', 'pin earring'],
    'type-ring': ['кольцо', 'кольца', 'перстень', 'ring'],
    'type-stud': ['пусет', 'гвоздик', 'stud'],
    'collection-cross': ['крест', 'крестик', 'крестом', 'cross'],
    'finish-arctic': ['арктик', 'арктический', 'arctic'],
    'finish-blackened': ['чернёный', 'черненый', 'чёрный', 'blackened'],
    'finish-bloody': ['кровавый', 'красный', 'bloody'],
    'finish-multicolor': ['мультиколор', 'разноцветный', 'multicolor'],
    'finish-silver': ['серебро', 'серебряный', 'silver'],
    'finish-toxic': ['токсик', 'кислотный', 'toxic']
  };

  var index = null;       // массив записей индекса
  var loadingPromise = null;

  /* Стоп-слова (предлоги/союзы) — не считаются обязательными в AND-логике,
   * иначе «кольцо из серебра» / «браслет с крестом» дают 0 (предлог не матчит товар). */
  var STOPWORDS = {
    'из': 1, 'для': 1, 'на': 1, 'от': 1, 'по': 1, 'за': 1, 'над': 1, 'под': 1, 'при': 1,
    'про': 1, 'без': 1, 'до': 1, 'со': 1, 'во': 1, 'не': 1, 'его': 1, 'нее': 1, 'неё': 1,
    'них': 1, 'или': 1, 'как': 1, 'что': 1, 'него': 1, 'нему': 1, 'ним': 1, 'ней': 1,
    'ему': 1, 'мне': 1, 'нам': 1, 'вам': 1, 'тебе': 1, 'меня': 1, 'тебя': 1, 'это': 1,
    'the': 1, 'of': 1, 'for': 1, 'with': 1, 'and': 1, 'or': 1, 'in': 1, 'on': 1, 'to': 1,
    'at': 1, 'by': 1, 'an': 1, 'is': 1, 'my': 1
  };
  function isSignif(w) { return w.length >= 2 && !STOPWORDS[w]; }

  var vocab = {};  // все токены каталога (title + синонимы) — для проверки «слово из каталога»
  // Слово обязательно в AND, только если оно реально присутствует в каталоге (точно или
  // как опечатка близкого токена). Иначе «кольцо для него» / «купить кольцо» дают 0.
  function wordIsLive(w) {
    if (vocab[w]) return true;
    if (w.length < 4) return false;
    var tol = w.length <= 5 ? 1 : 2;
    for (var tk in vocab) {
      if (Math.abs(tk.length - w.length) <= 2 && lev(w, tk) <= tol) return true;
    }
    return false;
  }

  /* ---------- нормализация ---------- */
  function normArticle(s) {
    return (s || '').toLowerCase().replace(/[^a-z0-9]/g, '');
  }
  function normText(s) {
    return (s || '')
      .toLowerCase()
      .replace(/ё/g, 'е')
      .replace(/[^a-zа-я0-9 ]/gi, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }
  function esc(s) {
    return (s || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* Расстояние Левенштейна с ранним выходом — для опечаток в словах */
  function lev(a, b) {
    var al = a.length, bl = b.length;
    if (Math.abs(al - bl) > 2) return 99;
    if (a === b) return 0;
    var prev = [], i, j;
    for (j = 0; j <= bl; j++) prev[j] = j;
    for (i = 1; i <= al; i++) {
      var cur = [i];
      var min = i;
      for (j = 1; j <= bl; j++) {
        var cost = a.charCodeAt(i - 1) === b.charCodeAt(j - 1) ? 0 : 1;
        cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + cost);
        if (cur[j] < min) min = cur[j];
      }
      if (min > 2) return 99; // дальше уже не уложимся в допуск
      prev = cur;
    }
    return prev[bl];
  }

  /* ---------- построение индекса ---------- */
  function buildIndex(products) {
    vocab = {};
    var arr = products.map(function (p) {
      var skus = [];
      (p.variants || []).forEach(function (v) { if (v.sku) skus.push(v.sku); });

      // Нормализованные формы артикула: K-0490-M → k0490m, k0490 (без размера), 0490 (номер), k0490
      var artSet = {};
      skus.forEach(function (sku) {
        var full = normArticle(sku);
        if (full) artSet[full] = sku;
        var parts = sku.toLowerCase().split('-');
        if (parts.length > 1) {
          var noSize = normArticle(parts.slice(0, parts.length - 1).join(''));
          if (noSize) artSet[noSize] = sku;
        }
        if (parts[1]) {
          var num = normArticle(parts[1]);
          if (num) artSet[num] = sku;
          if (parts[0]) artSet[normArticle(parts[0] + parts[1])] = sku;
        }
      });

      var facet = [];
      (p.tags || []).forEach(function (t) {
        if (SYNONYMS[t]) facet = facet.concat(SYNONYMS[t]);
      });

      var firstAvail = null, anyVariant = (p.variants || [])[0] || {};
      (p.variants || []).forEach(function (v) { if (!firstAvail && v.available) firstAvail = v; });
      var v0 = firstAvail || anyVariant;
      var img = (p.images && p.images[0] && p.images[0].src) || '';

      return {
        title: p.title,
        url: '/products/' + p.handle,
        img: img,
        available: !!(v0 && v0.available),
        art: artSet,                          // {нормформа: исходный sku}
        artKeys: Object.keys(artSet),
        titleN: normText(p.title),
        facetN: normText(facet.join(' '))
      };
    });
    // словарь каталога — все токены названий и синонимов
    arr.forEach(function (it) {
      (it.titleN + ' ' + it.facetN).split(' ').forEach(function (w) { if (w.length >= 2) vocab[w] = 1; });
    });
    return arr;
  }

  function loadFeed() {
    // кэш в sessionStorage
    try {
      var raw = sessionStorage.getItem(CACHE_KEY);
      if (raw) {
        var c = JSON.parse(raw);
        if (c && c.t && (Date.now() - c.t) < CACHE_TTL && c.data) {
          return Promise.resolve(c.data);
        }
      }
    } catch (e) { /* приватный режим / нет места — игнор */ }

    // пагинация на будущее (если каталог перерастёт 250)
    var all = [];
    function page(n) {
      return fetch(FEED + '&page=' + n, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (d) {
          var prods = (d && d.products) || [];
          all = all.concat(prods);
          if (prods.length === 250 && n < 6) return page(n + 1);
          return all;
        });
    }
    return page(1).then(function (prods) {
      try {
        sessionStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), data: prods }));
      } catch (e) { /* игнор */ }
      return prods;
    });
  }

  function ensureIndex() {
    if (index) return Promise.resolve(index);
    if (loadingPromise) return loadingPromise;
    loadingPromise = loadFeed().then(function (prods) {
      index = buildIndex(prods);
      return index;
    });
    return loadingPromise;
  }

  /* ---------- скоринг ---------- */
  // liveWords — значимые слова запроса, реально присутствующие в каталоге (AND строится
  // только по ним; слова не из каталога, как «для»/«него»/«купить», не обнуляют выдачу).
  function score(it, qArt, liveWords) {
    var s = 0, hitSku = null;

    // 1) Артикул: точное > префикс > запрос-содержит-артикул > подстрока
    if (qArt && qArt.length >= 2) {
      for (var i = 0; i < it.artKeys.length; i++) {
        var a = it.artKeys[i];
        var local = 0;
        if (a === qArt) local = 100;
        else if (a.indexOf(qArt) === 0) local = 92;
        else if (qArt.indexOf(a) === 0 && a.length >= 4) local = 84;
        else if (a.length >= 4 && a.indexOf(qArt) > -1 && qArt.length >= 4) local = 74;
        if (local > s) { s = local; hitSku = it.art[a]; }
      }
    }

    // 2) Текст: «живые» слова ищем по title + синонимам фасетов (с опечатками)
    if (liveWords.length) {
      var hay = (it.titleN + ' ' + it.facetN).split(' ').filter(Boolean);
      var matched = 0, textScore = 0;
      for (var t = 0; t < liveWords.length; t++) {
        var qt = liveWords[t];
        var best = -1;
        for (var j = 0; j < hay.length; j++) {
          var ht = hay[j], local2 = -1;
          if (ht === qt) local2 = 60;
          else if (ht.indexOf(qt) === 0) local2 = 50;
          else if (qt.length >= 4) {
            var d = lev(qt, ht);
            var tol = qt.length <= 5 ? 1 : 2;
            if (d <= tol) local2 = 44 - d * 8;
          }
          if (local2 > best) best = local2;
        }
        if (best >= 0) { matched++; textScore = Math.max(textScore, best); }
      }
      var need = liveWords.length;
      if (need >= 2) {
        // Многословный — обязательны ВСЕ «живые» слова (И «carbon», И «bracelet»).
        if (matched === need) s = Math.max(s, textScore + 25);
      } else if (matched) {
        s = Math.max(s, textScore);
      }
    }

    return { s: s, sku: hitSku };
  }

  function runSearch(query, limit) {
    query = (query || '').trim();
    if (!query || !index) return [];
    var qArt = normArticle(query);
    var qTok = normText(query).split(' ').filter(Boolean);
    var liveWords = qTok.filter(isSignif).filter(wordIsLive);
    var out = [];
    for (var i = 0; i < index.length; i++) {
      var r = score(index[i], qArt, liveWords);
      if (r.s > 0) out.push({ it: index[i], s: r.s, sku: r.sku });
    }
    out.sort(function (a, b) {
      return (b.s - a.s) || ((b.it.available ? 1 : 0) - (a.it.available ? 1 : 0));
    });
    return out.slice(0, limit || MAX_PREDICTIVE);
  }

  /* ---------- рендер карточки в дизайне темы (.search-item) ---------- */
  // big=true — крупная плитка для страницы /search (фото на всю ширину, object-fit:contain
  //   как в каталоге); big=false — мелкая миниатюра 110px для предиктивной выпадашки.
  function thumb(src, big) {
    var w = big ? 600 : 120;
    if (!src) return big ? '<div class="thumbnail" style="aspect-ratio:1/1;background:#f3f3f1"></div>' : '';
    var u = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
    if (big) {
      // width:100% + aspect-ratio:1/1 + object-fit:cover — фото заполняет квадрат плитки
      // на всю ширину (как карточка каталога), независимо от CSS темы.
      return '<div class="thumbnail" style="width:100%;aspect-ratio:1/1;overflow:hidden;margin:0">'
        + '<img src="' + esc(u) + '" alt="" loading="lazy" style="width:100%;height:100%;object-fit:cover"></div>';
    }
    return '<div class="thumbnail"><img src="' + esc(u) + '" alt="" loading="lazy" width="110" height="110"></div>';
  }
  function card(hit, big) {
    var it = hit.it;
    var caption = hit.sku ? '<span class="caption"><span class="text-size--smaller">арт. ' + esc(hit.sku) + '</span></span>' : '';
    // big: форсим вертикальную карточку (фото сверху на всю ширину, текст снизу) —
    // иначе в темах с горизонтальной .search-item фото остаётся узким сбоку.
    var cardStyle = big ? ' style="display:flex;flex-direction:column;align-items:stretch"' : '';
    return '<a class="search-item" data-js-search-item' + cardStyle + ' href="' + esc(it.url) + '" title="' + esc(it.title) + '" tabindex="-1">'
      + thumb(it.img, big)
      + '<div class="content">'
      + '<span class="item-title"><span class="underline-animation">' + esc(it.title) + '</span></span>'
      + caption
      + '</div></a>';
  }

  /* ---------- 1) Патч предиктивного поиска темы ---------- */
  function patchPredictive(attempt) {
    attempt = attempt || 0;
    var ctor = (window.customElements && customElements.get('search-form'));
    if (!ctor) {
      if (attempt < 40) return setTimeout(function () { patchPredictive(attempt + 1); }, 250);
      return;
    }
    var proto = ctor.prototype;
    if (proto.__strugaPatched) return;
    proto.__strugaPatched = true;

    var origGet = proto.getSearchResults;

    proto.getSearchResults = function (query) {
      query = (query || '').trim();
      var self = this;
      if (!query) { if (self.clearSearchResults) self.clearSearchResults(); return; }
      if (self.preloadSearchResults) self.preloadSearchResults();

      ensureIndex().then(function () {
        var hits = runSearch(query, MAX_PREDICTIVE);

        // нативный suggest — берём из него только статьи/страницы (товары — наши)
        var nativeUrl = (window.KROWN && KROWN.settings.routes.predictive_search_url || '/search/suggest')
          + '?q=' + encodeURIComponent(query) + '&section_id=helper-predictive-search';

        fetch(nativeUrl, { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.text() : ''; })
          .catch(function () { return ''; })
          .then(function (text) {
            var nonProduct = '';
            if (text) {
              try {
                var doc = new DOMParser().parseFromString(text, 'text/html');
                var sec = doc.querySelector('#shopify-section-helper-predictive-search') || doc;
                var links = sec.querySelectorAll('a.search-item');
                for (var k = 0; k < links.length; k++) {
                  var href = links[k].getAttribute('href') || '';
                  if (href.indexOf('/blogs/') > -1 || href.indexOf('/pages/') > -1) {
                    links[k].setAttribute('data-js-search-item', '');
                    links[k].setAttribute('tabindex', '-1');
                    nonProduct += links[k].outerHTML;
                  }
                }
              } catch (e) { /* игнор парсинга */ }
            }

            var html = '';
            html += hits.map(card).join('');
            if (nonProduct) {
              html += '<span class="sidebar-divider">' + (hits.length ? 'Журнал и страницы' : '') + '</span>' + nonProduct;
            }

            if (!html) {
              // ничего не нашли даже умным поиском — отдадим нативный рендер целиком
              if (text) {
                try {
                  var d2 = new DOMParser().parseFromString(text, 'text/html');
                  var s2 = d2.querySelector('#shopify-section-helper-predictive-search');
                  self.predictiveSearchResults.innerHTML = s2 ? s2.innerHTML : '';
                } catch (e2) { self.predictiveSearchResults.innerHTML = ''; }
              } else {
                self.predictiveSearchResults.innerHTML = '';
              }
            } else {
              var allLink = '<div class="sidebar__search-link"><a tabindex="-1" class="button button--solid" href="/search?q='
                + encodeURIComponent(query) + '&options%5Bprefix%5D=last"><span class="button-scroll-in">Показать всё</span></a></div>';
              self.predictiveSearchResults.innerHTML = '<div class="sidebar__search-container"><div class="sidebar__search-results">'
                + html + '</div></div>' + allLink;
            }
            self.preloader = false;
            self.results = self.predictiveSearchResults.querySelectorAll('[data-js-search-item]');
          });
      }).catch(function () {
        // полный откат на нативный предиктив
        if (origGet) origGet.call(self, query);
      });
    };
  }

  /* ---------- контент-индекс: статьи и страницы (для законченной логики поиска) ---------- */
  var contentIndex = null, contentLoading = null;
  function isRu() { return /\.ru$/i.test(location.hostname); }

  function prepContent(arr) {
    return (arr || []).map(function (it) {
      it._t = normText(it.title);
      it._x = normText(it.x);
      it._a = normArticle(it.x);
      // Слова из адреса — латиница даже в русском указателе. Без этого запрос
      // «brands like» не находит статью «Бренды как Chrome Hearts», хотя её адрес
      // это дословно содержит: русский указатель по-русски, а адрес нет.
      it._u = normText(String(it.u || '').replace(/[\/\-_]+/g, ' '));
      return it;
    });
  }
  function loadContent() {
    if (contentIndex) return Promise.resolve(contentIndex);
    if (contentLoading) return contentLoading;
    var ru = isRu();
    var url = ru ? window.STRUGA_CONTENT_RU : window.STRUGA_CONTENT_EN;
    if (!url) { contentIndex = []; return Promise.resolve(contentIndex); }
    var ck = 'struga_content_' + (ru ? 'ru' : 'en') + '_v1';
    try {
      var raw = sessionStorage.getItem(ck);
      if (raw) { contentIndex = prepContent(JSON.parse(raw)); return Promise.resolve(contentIndex); }
    } catch (e) {}
    contentLoading = fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : []; })
      .then(function (arr) {
        try { sessionStorage.setItem(ck, JSON.stringify(arr)); } catch (e) {}
        contentIndex = prepContent(arr);
        return contentIndex;
      })
      .catch(function () { contentIndex = []; return contentIndex; });
    return contentLoading;
  }

  function searchContent(query, limit) {
    if (!contentIndex || !contentIndex.length) return [];
    var qTok = normText(query).split(' ').filter(isSignif);
    var qArt = normArticle(query);
    var out = [];
    for (var i = 0; i < contentIndex.length; i++) {
      var it = contentIndex[i], textScore = 0, textMatched = 0;
      for (var t = 0; t < qTok.length; t++) {
        var qt = qTok[t];
        if (it._t.indexOf(qt) > -1) { textScore += 40; textMatched++; }
        else if (it._x.indexOf(qt) > -1) { textScore += 18; textMatched++; }
        else if (it._u && it._u.indexOf(qt) > -1) { textScore += 12; textMatched++; }
      }
      var s = 0;
      // AND: многословный текстовый запрос — обязательны все значимые слова
      if (qTok.length < 2 || textMatched === qTok.length) {
        s += textScore;
        if (qTok.length && textMatched === qTok.length) s += 12;
      }
      // артикул — независимо от текстовых слов
      if (qArt.length >= 2 && /[0-9]/.test(qArt) && it._a.indexOf(qArt) > -1) s += 50;
      if (s > 0) out.push({ it: it, s: s });
    }
    out.sort(function (a, b) { return b.s - a.s; });
    return out.slice(0, limit || 12).map(function (x) { return x.it; });
  }

  function snippet(text, query) {
    var qTok = normText(query).split(' ').filter(function (x) { return x.length >= 2; });
    var low = text.toLowerCase();
    var pos = -1;
    for (var t = 0; t < qTok.length; t++) { var i = low.indexOf(qTok[t]); if (i > -1) { pos = i; break; } }
    if (pos < 0) return text.slice(0, 140) + (text.length > 140 ? '…' : '');
    var start = Math.max(0, pos - 45);
    return (start > 0 ? '…' : '') + text.slice(start, pos + 95).trim() + '…';
  }

  function contentCard(it, query) {
    return '<a class="search-item article" href="' + esc(it.u) + '" title="' + esc(it.title) + '" tabindex="-1" style="grid-column:1/-1">'
      + '<div class="content">'
      + '<span class="item-title"><span class="underline-animation">' + esc(it.title) + '</span></span>'
      + '<span class="caption"><span class="text-size--smaller">' + esc(snippet(it.x, query)) + '</span></span>'
      + '</div></a>';
  }

  // Скрыть нативные блоки статей/страниц темы (мы рендерим свои, полные)
  function hideNativeContent() {
    var wrap = document.querySelector('#section-search .search-results.predictive-search');
    if (!wrap) return;
    [].forEach.call(wrap.children, function (el) {
      if (el.id === 'main-collection-product-grid' || el.id === 'struga-content-results') return;
      el.style.display = 'none';
    });
  }

  function renderContent(query) {
    return loadContent().then(function () {
      var hits = searchContent(query, 60);
      var wrap = document.querySelector('#section-search .search-results.predictive-search');
      if (!wrap) return 0;
      var host = document.getElementById('struga-content-results');
      if (!host) { host = document.createElement('div'); host.id = 'struga-content-results'; wrap.appendChild(host); }
      // Нативные статьи и страницы прячем ТОЛЬКО когда есть чем заменить.
      // Раньше пряталось безусловно: свой указатель давал ноль, нативная выдача
      // уже была скрыта, и человек видел пустой экран при 192 найденных.
      // Та же страховка, что для товаров ниже: наш поиск пуст — натив не трогаем.
      if (!hits.length) { host.innerHTML = ''; return 0; }
      hideNativeContent();
      tookOver = true;
      // раздельные квоты, чтобы и статьи, и страницы попадали в выдачу
      var articles = hits.filter(function (h) { return h.t === 'article'; }).slice(0, 24);
      var pages = hits.filter(function (h) { return h.t === 'page'; }).slice(0, 12);
      var ru = isRu();
      var html = '';
      if (articles.length) {
        html += '<span class="text-size--larger" style="display:block;margin:3em auto 1.5em">' + (ru ? 'Журнал' : 'From the journal') + '</span>'
          + articles.map(function (it) { return contentCard(it, query); }).join('');
      }
      if (pages.length) {
        html += '<span class="text-size--larger" style="display:block;margin:3em auto 1.5em">' + (ru ? 'Страницы' : 'Pages') + '</span>'
          + pages.map(function (it) { return contentCard(it, query); }).join('');
      }
      host.innerHTML = html;
      return articles.length + pages.length;
    });
  }

  /* ---------- 2) Дозаполнение страницы /search, когда натив дал 0 ---------- */
  // UX-фиксы заголовка темы — применяем при ЛЮБОЙ выдаче (и нативной, и нашей):
  // тема держит блок-заголовок min-height ~на весь экран (956px) и position:sticky,
  // из-за чего результаты уезжают под фолд и заголовок наезжает на карточки.
  function fixSearchLayout() {
    var headingBox = document.querySelector('#section-search .site-box[data-order="0"]');
    if (!headingBox) return;
    headingBox.style.position = 'static';
    headingBox.style.minHeight = '0';
    var rtm = headingBox.querySelector('.reduce-top-margin');
    if (rtm) rtm.style.minHeight = '0';
  }

  function pluralRu(n, forms) {
    var n10 = n % 10, n100 = n % 100;
    if (n10 === 1 && n100 !== 11) return forms[0];
    if (n10 >= 2 && n10 <= 4 && (n100 < 10 || n100 >= 20)) return forms[1];
    return forms[2];
  }
  // Считаем то, что РЕАЛЬНО видно на экране: карточки товаров плюс видимые карточки
  // статей и страниц (наши или нативные — неважно). Прежний счётчик брал только товары,
  // и при нуле товаров с десятком статей на экране писал «0 товаров» — цифра
  // противоречила тому, что человек видит.
  function visibleResultCount() {
    var wrap = document.querySelector('#section-search .search-results.predictive-search');
    if (!wrap) return { products: 0, content: 0 };
    var products = 0, content = 0;
    [].forEach.call(wrap.querySelectorAll('a.search-item'), function (a) {
      for (var p = a.parentElement; p && p !== wrap; p = p.parentElement) {
        if (p.style && p.style.display === 'none') return;
      }
      if (a.getAttribute('href') && a.getAttribute('href').indexOf('/products/') > -1) products++;
      else content++;
    });
    return { products: products, content: content };
  }

  // Постраничная навигация принадлежит НАТИВНОЙ выдаче: она разбита на страницы,
  // наша — нет. Поэтому показываем её только когда на экране осталась нативная
  // выдача целиком. Как только скрипт подменил товары или содержимое — навигация
  // ведёт либо в пустоту, либо на повтор тех же карточек, и её надо убрать.
  var tookOver = false;
  function togglePagination() {
    var p = document.querySelector('#CollectionProductGrid .pagination');
    if (p) p.style.display = tookOver ? 'none' : '';
  }

  function showEmptyState(q, show) {
    var wrap = document.querySelector('#section-search .search-results.predictive-search');
    if (!wrap) return;
    var box = document.getElementById('struga-search-empty');
    if (!show) { if (box) box.remove(); return; }
    if (!box) { box = document.createElement('div'); box.id = 'struga-search-empty'; wrap.appendChild(box); }
    box.style.cssText = 'grid-column:1/-1;margin:2em 0;line-height:1.8;';
    box.innerHTML = isRu()
      ? '<p>По запросу «' + esc(q) + '» ничего не нашлось.</p><p>Попробуйте одно слово вместо нескольких, или загляните в <a href="/collections/all">каталог</a> и <a href="/blogs/journal">журнал</a>.</p>'
      : '<p>Nothing found for "' + esc(q) + '".</p><p>Try a single word instead of a phrase, or browse the <a href="/collections/all">catalogue</a> and the <a href="/blogs/journal">journal</a>.</p>';
  }

  function updateCount(q) {
    var sub = document.querySelector('#section-search .subtitle');
    if (!sub) return;
    var c = visibleResultCount();
    var total = c.products + c.content;
    if (total === 0) tookOver = true;   // нечего показывать — навигация ведёт в пустоту
    togglePagination();
    showEmptyState(q, total === 0);
    if (total === 0) {
      sub.textContent = isRu() ? 'Ничего не нашлось по запросу «' + q + '»' : 'Nothing found for "' + q + '"';
      return;
    }
    var parts = [];
    if (isRu()) {
      if (c.products) parts.push(c.products + ' ' + pluralRu(c.products, ['товар', 'товара', 'товаров']));
      if (c.content) parts.push(c.content + ' ' + pluralRu(c.content, ['материал', 'материала', 'материалов']));
      sub.textContent = parts.join(' и ') + ' по запросу «' + q + '»';
    } else {
      if (c.products) parts.push(c.products + (c.products === 1 ? ' product' : ' products'));
      if (c.content) parts.push(c.content + (c.content === 1 ? ' article or page' : ' articles and pages'));
      sub.textContent = parts.join(' and ') + ' for "' + q + '"';
    }
  }

  function enhanceSearchPage() {
    if (!/\/search\b/.test(location.pathname)) return;
    var q = new URLSearchParams(location.search).get('q');
    if (!q) return;
    var grid = document.querySelector('#main-collection-product-grid');
    if (!grid) return;

    // Статьи и страницы — умный контент-поиск ВСЕГДА (полная законченная логика).
    // Счётчик пересчитываем ПОСЛЕ отрисовки: указатель грузится запросом, и до его
    // прихода на экране ещё нативная выдача — иначе счётчик считает не то состояние.
    renderContent(q).then(function () { updateCount(q); });
    // Компактный заголовок и снятие прилипания — всегда, для хорошего UX
    fixSearchLayout();
    updateCount(q);

    // Товарную выдачу ВСЕГДА отдаём своему релевантному поиску (AND по словам, синонимы,
    // артикулы). Нативный поиск Shopify по тексту слишком широкий — OR-логика: «carbon
    // bracelet» тянет любые браслеты и любой карбон по отдельности. Fallback: если наш
    // поиск пуст, а нативный что-то нашёл — оставляем нативную выдачу нетронутой.
    ensureIndex().then(function () {
      var hits = runSearch(q, MAX_PAGE);
      if (!hits.length) { renderContent(q).then(function () { updateCount(q); }); return; }

      grid.innerHTML = hits.map(function (h) { return card(h, true); }).join('');
      tookOver = true;

      // Принудительная сетка — не полагаемся на CSS темы (в одних темах грид display:grid,
      // в других display:block с мелкими горизонтальными карточками). Задаём сетку сами,
      // чтобы карточки были одинаковыми плитками на любой теме.
      grid.style.display = 'grid';
      grid.style.gridTemplateColumns = 'repeat(auto-fill, minmax(220px, 1fr))';
      grid.style.gap = '44px 28px';

      // при нулевой нативной выдаче форма «искать снова» и сетка — два ребёнка flex-row,
      // сетка сжимается вдвое. Колонка → форма сверху, сетка на всю ширину.
      var boxContent = grid.closest('.site-box-content');
      if (boxContent) boxContent.style.flexDirection = 'column';
      fixSearchLayout();

      updateCount(q);
      var h1 = document.querySelector('#section-search h1.title');
      if (h1 && /STRUGA/i.test(h1.textContent)) h1.textContent = isRu() ? 'Результаты поиска' : 'Search results';

      // убрать нативное «Ничего не нашлось»
      document.querySelectorAll('#section-search p, #section-search .subtitle ~ *').forEach(function (el) {
        if (/ничего не нашл|попробуйте другое|try another/i.test(el.textContent || '')) el.style.display = 'none';
      });

      // контент перерисовываем после товаров (грид мог перестроиться)
      renderContent(q).then(function () { updateCount(q); });
    });
  }

  /* ---------- init ---------- */
  function init() {
    patchPredictive();
    enhanceSearchPage();
    // прогрев индекса при первом фокусе на любом поле поиска — чтобы первая выдача была мгновенной
    document.addEventListener('focusin', function (e) {
      var t = e.target;
      if (t && (t.matches('[data-js-search-input]') || (t.getAttribute && t.getAttribute('type') === 'search'))) {
        ensureIndex();
      }
    }, { once: false });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Экспорт ядра — для отладки в консоли и автотестов (не влияет на работу).
  if (typeof window !== 'undefined') {
    window.StrugaSmartSearch = {
      buildIndex: buildIndex,
      runSearch: runSearch,
      setIndex: function (prods) { index = buildIndex(prods); return index; },
      _get: function () { return index; }
    };
  }
})();
